import { useCallback, useState, useMemo, useRef } from 'react'
import { find } from 'ramda'
import cn from 'classnames/bind'

import PlainDropdown, { PlainDropdownDefitem } from 'app/common/ui-next/plain-dropdown'
import { SaleType } from 'app/dataTypes/dishes/saleType'
import PlainIcon, { iconColor, iconType } from 'app/common/ui-next/plain-icon'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'

import styles from './CellContentSaleTypeWithPen.module.scss'

const cx = cn.bind(styles)

type Props = {
  id: string
  className?: string
  currentSaleTypeId: string | null
  pending: boolean
  saleTypes: Array<SaleType>
  locked?: boolean
  onChangeSaleType: (value: string) => Promise<boolean>
}

export const CellContentSaleTypeWithPen = ({
  id,
  className,
  pending,
  currentSaleTypeId,
  saleTypes,
  locked,
  onChangeSaleType,
}: Props) => {
  const [disabled, setDisabled] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const editModeMounted = useRef(false)

  const handleChangeSaleType = useCallback(
    async ({ id: value }: { id: string }) => {
      setDisabled(true)
      const res = await onChangeSaleType(value)
      setDisabled(false)
      if (res) {
        setEditMode(false)
        editModeMounted.current = false
      }
    },
    [onChangeSaleType],
  )

  const handleCollapseListbox = () => {
    console.log({ mounted: editModeMounted.current, editMode })
    if (editModeMounted.current && editMode) {
      setEditMode(false)
      editModeMounted.current = false
      return
    }
    editModeMounted.current = true
  }

  const currentTitle = useMemo(() => {
    return (find(({ id: saleTypeId }) => saleTypeId === currentSaleTypeId, saleTypes) || {}).title
  }, [currentSaleTypeId, saleTypes])

  return (
    <div className={cx(styles.root, { heightRestricted: editMode }, className)}>
      {locked || !editMode ? (
        <span className={styles.readModeContainer}>
          <span className={styles.readModeValue}>{currentTitle}</span>
          <PlainButtonAsLink onClick={() => setEditMode(true)}>
            <PlainIcon type={iconType.PEN} color={iconColor.COLOR_TEXT} />
          </PlainButtonAsLink>
        </span>
      ) : (
        <>
          <span className={styles.hiddenValue} aria-hidden="true">
            {currentTitle}
          </span>

          <PlainDropdown
            defaultSkin
            id={`saleType_${id}`}
            label="Тип продукции"
            className={styles.content}
            labelClassName="visuallyHidden"
            onChange={handleChangeSaleType}
            disabled={pending || disabled}
            onCollapseListbox={handleCollapseListbox}
            placeholder={
              <PlainDropdownDefitem id="placeholder" disabled={pending || disabled}>
                {'Не задан'}
              </PlainDropdownDefitem>
            }
          >
            {saleTypes.map(({ id: saleTypeId, title }) => (
              <PlainDropdownDefitem
                key={saleTypeId}
                id={saleTypeId}
                selected={saleTypeId === currentSaleTypeId}
                disabled={pending || disabled}
              >
                {title}
              </PlainDropdownDefitem>
            ))}
          </PlainDropdown>
        </>
      )}
    </div>
  )
}
